import React, { useState } from 'react'
import { Box, styled } from '@mui/material'
import ModernProfileSidebar from './components/modern/ModernProfileSidebar'
import ProfileSection from './components/modern/sections/ProfileSection'
import ContentSection from './components/modern/sections/ContentSection'
import BillingSection from './components/modern/sections/BillingSection'
import AccountSection from './components/modern/sections/AccountSection'
import SecuritySection from './components/modern/sections/SecuritySection'

// ==================== TYPES ====================
export type ProfileTab = 'profile' | 'content' | 'billing' | 'account' | 'security'

// ==================== STYLED COMPONENTS ====================
const PageContainer = styled(Box)({
  minHeight: '100vh',
  backgroundColor: '#fafbfc',
  display: 'flex',
})

const ContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  marginLeft: '280px',
  padding: '32px 40px',
  minHeight: '100vh',

  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    padding: '24px 20px',
  },
}))

const SectionContainer = styled(Box)({
  maxWidth: '1000px',
  margin: '0 auto',
})

// ==================== COMPONENT ====================
const ModernProfilePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ProfileTab>('profile')

  const renderSection = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileSection />
      case 'content':
        return <ContentSection />
      case 'billing':
        return <BillingSection />
      case 'account':
        return <AccountSection />
      case 'security':
        return <SecuritySection />
      default:
        return <ProfileSection />
    }
  }

  return (
    <PageContainer>
      <ModernProfileSidebar activeTab={activeTab} onTabChange={setActiveTab} />
      <ContentArea>
        <SectionContainer>{renderSection()}</SectionContainer>
      </ContentArea>
    </PageContainer>
  )
}

export default ModernProfilePage
